import Tenders from './Tenders';

export default Tenders;
